import { render, staticRenderFns } from "./acknowledgementGrid.vue?vue&type=template&id=156ddecc"
import script from "./acknowledgementGrid.vue?vue&type=script&lang=js"
export * from "./acknowledgementGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports